<!-- HR requested a correction of the onboarding form -->
<div *ngIf="isCorrectionRequested(task); else newOnboarding"
     class="onboarding-card onboarding-card--correction">

  <div class="onboarding-card__icon onboarding-card__icon--correction">
    <em class="fa fa-light fa-pen-to-square"></em>
  </div>

  <h4 class="onboarding-card__title">{{ 'ONBOARDING.correction_task_title' | translate }}</h4>

  <p class="onboarding-card__greeting">{{ 'ONBOARDING.fill_onboarding_task_greeting' | translate
        | translateAndFormatVariables: task.variables: (trigger$|async) }}</p>
  <p>{{ 'ONBOARDING.correction_task_intro' | translate }}</p>

  <div class="onboarding-card__comment" *ngIf="getValidatorComment(task) as validatorComment">
    <div class="onboarding-card__comment-label">
      <em class="fa fa-light fa-comment-dots m-r-xs"></em>
      {{ 'ONBOARDING.correction_task_comment_label' | translate }}
    </div>
    <p class="onboarding-card__comment-text">{{ validatorComment }}</p>
  </div>

  <p>{{ 'ONBOARDING.correction_task_instruction' | translate }}</p>

  <a class="btn btn-primary onboarding-card__cta"
     [href]="onboardingUrl" target="_blank" rel="noopener noreferrer">
    <em class="fa fa-light fa-arrow-up-right-from-square m-r-xs"></em>
    {{ 'ONBOARDING.correction_task_cta' | translate }}
  </a>

  <p class="onboarding-card__note">
    <em class="fa fa-light fa-circle-info m-r-xs"></em>
    {{ 'ONBOARDING.correction_task_note' | translate }}
  </p>

  <div class="onboarding-card__footer">
    <p>{{ 'ONBOARDING.fill_onboarding_task_closing' | translate }}</p>
    <p class="onboarding-card__regards">{{ 'ONBOARDING.fill_onboarding_task_regards' | translate }}</p>
  </div>
</div>

<!-- First time: fill the onboarding form -->
<ng-template #newOnboarding>
  <div class="onboarding-card">

    <div class="onboarding-card__icon">
      <em class="fa fa-light fa-hands-clapping"></em>
    </div>

    <h4 class="onboarding-card__title">{{ 'ONBOARDING.fill_onboarding_task_title' | translate }}</h4>

    <p class="onboarding-card__greeting">{{ 'ONBOARDING.fill_onboarding_task_greeting' | translate
          | translateAndFormatVariables: task?.variables: (trigger$|async) }}</p>
    <p>{{ 'ONBOARDING.fill_onboarding_task_welcome' | translate }}</p>
    <p>{{ 'ONBOARDING.fill_onboarding_task_intro' | translate }}</p>

    <a class="btn btn-primary onboarding-card__cta"
       [href]="onboardingUrl" target="_blank" rel="noopener noreferrer">
      <em class="fa fa-light fa-arrow-up-right-from-square m-r-xs"></em>
      {{ 'ONBOARDING.fill_onboarding_task_cta' | translate }}
    </a>

    <p class="onboarding-card__note">
      <em class="fa fa-light fa-circle-info m-r-xs"></em>
      {{ 'ONBOARDING.fill_onboarding_task_note' | translate }}
    </p>

    <div class="onboarding-card__footer">
      <p>{{ 'ONBOARDING.fill_onboarding_task_closing' | translate }}</p>
      <p class="onboarding-card__regards">{{ 'ONBOARDING.fill_onboarding_task_regards' | translate }}</p>
    </div>
  </div>
</ng-template>

